import type { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios'

/**
 * 设置请求拦截器
 */
export function setupRequestInterceptor(client: AxiosInstance) {
  client.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // 添加认证token
      const token = localStorage.getItem('authToken')
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }

      console.log(`📤 [API] ${config.method?.toUpperCase()} ${config.url}`, {
        data: config.data instanceof FormData ? '[FormData]' : config.data,
        params: config.params,
      })

      return config
    },
    (error) => {
      console.error('❌ [API] Request Error:', error)
      return Promise.reject(error)
    }
  )
}

/**
 * 设置响应拦截器
 */
export function setupResponseInterceptor(client: AxiosInstance) {
  client.interceptors.response.use(
    (response: AxiosResponse) => {
      console.log(`✅ [API] ${response.config.method?.toUpperCase()} ${response.config.url}`, {
        status: response.status,
        data: response.data,
      })

      return response
    },
    (error) => {
      // ✅ 忽略取消请求的错误日志 (AbortController 或 axios cancel)
      const isCancelError =
        error.code === 'ERR_CANCELED' ||
        error.name === 'AbortError' ||
        error.name === 'CanceledError' ||
        error.message === 'canceled'

      if (!isCancelError) {
        // ✅ 只记录真正的错误
        console.error(`❌ [API] ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        })
      }

      // 统一错误处理
      if (error.response?.status === 401) {
        localStorage.removeItem('authToken')
        localStorage.removeItem('loginTime')
        window.location.href = '/login'
      }

      return Promise.reject(error)
    }
  )
}

/**
 * 初始化API拦截器
 */
export function setupInterceptors(client: AxiosInstance) {
  setupRequestInterceptor(client)
  setupResponseInterceptor(client)
}
